import React, { useEffect, useState } from 'react'
import { useSpring, animated } from 'react-spring'
import illust from '../../imports/illust'
import samune from '../../imports/samune'
import startBtn from '../../img/parts/再生ボタン.png'
import linklist from '../list/link'
import namelist from '../list/name'
import hokuro from '../../img/parts/ほくろ3.png'

const IllustArray = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [selectedIndex, setSelectedIndex] = useState<number>(0)
  const [scroll, setScroll] = useState<string>('visible')
  const [loading, setLoading] = useState(true)

  const IllustBox: string[] = illust()
  const samuneImage: string[] = samune()
  const link: string[] = linklist()
  const name: string[] = namelist()

  document.body.style.overflow = scroll

  const openModal = (index: number) => {
    setSelectedImage(IllustBox[index])
    setSelectedIndex(index)
    setScroll('hidden')
  }

  const closeModal = () => {
    setSelectedImage(null)
    setScroll('visible')
  }

  const youtubeLink = (index: number) => {
    window.open(link[index], '_blank')
  }

  const scaleAnimation = useSpring({
    transform: `scale(${selectedImage ? 1 : 0.5})`,
  })

  const backgroundAnimation = useSpring({
    opacity: selectedImage ? 1 : 0,
    backgroundColor: selectedImage ? 'rgba(0, 0, 0, 0.75)' : 'rgba(0, 0, 0, 0)',
  })

  //ページを開いたらダウンロード
  const downloadImage = async () => {
    const imageUrls = illust()

    // 各画像のURLに対してImageオブジェクトを作成し、読み込み完了を待つ
    await Promise.all(
      imageUrls.map((url) => {
        return new Promise((resolve) => {
          const IllustBox = new Image()
          IllustBox.src = url
          IllustBox.onload = () => {
            resolve(null)
          }
        })
      }),
    )
  }
  const downloadSamune = async () => {
    const imageUrls = samune()

    try {
      await Promise.all(
        imageUrls.map((url) => {
          return new Promise((resolve) => {
            const IllustBox = new Image()
            IllustBox.src = url
            IllustBox.onload = () => {
              resolve(null)
            }
          })
        }),
      )
    } finally {
      // ロード完了後、ローディング状態を終了
      setLoading(false)
    }
  }
  useEffect(() => {
    downloadSamune()
    downloadImage()
  }, [])

  if (loading) {
    return (
      <div className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
        {/* <div className="h-10 w-10 animate-spin rounded-full border-4 border-nemoBlue border-t-transparent"></div> */}
        <img
          src={hokuro}
          alt=""
          className="h-10 w-10 animate-spin object-contain "
        />
      </div>
    )
  }

  return (
    <>
      {samuneImage.map((image, index) => (
        <div className="relative rounded-xl bg-blue-200 bg-opacity-50 object-contain text-center shadow">
          <img
            key={index}
            src={image}
            alt={`samuneImage ${index}`}
            className=" aspect-ratio: 9 / 16 rounded-transition transform rounded-t-xl shadow transition-transform duration-300 hover:scale-105"
            onClick={() => openModal(index)}
          />
          <button
            onClick={() => youtubeLink(index)}
            className="my-2 w-full transform rounded-full bg-nemoBlue py-2  text-xs text-white  shadow transition-transform duration-300 hover:scale-105 hover:bg-sky-400 xl:w-4/5 xl:text-base xl:font-bold"
          >
            <div className=" flex h-full items-center justify-center">
              <img
                src={startBtn}
                alt="start"
                className="h-4 w-4 xl:h-6 xl:w-6"
              />
              　{name[index]}
            </div>
          </button>
        </div>
      ))}

      {selectedImage && (
        <div>
          <animated.div
            style={backgroundAnimation}
            className="fixed left-0 top-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-white "
            onClick={closeModal}
          >
            <div className="flex  h-screen w-fit flex-col items-center justify-center px-2 leading-8 ">
              <animated.img
                style={scaleAnimation}
                src={selectedImage}
                alt={`selectedImage`}
                className="sm:h-3/5 lg:h-3/4 "
              />
              <button
                onClick={() => youtubeLink(selectedIndex)}
                className="my-2 w-full transform rounded-full bg-nemoBlue px-4  py-2 text-white shadow transition-transform duration-300 hover:scale-105 hover:bg-sky-400 xl:font-bold"
              >
                {/* Listen to ▶ {name[selectedIndex]} */}
                <div className="flex h-full items-center justify-center ">
                  <img
                    src={startBtn}
                    alt="start"
                    className="h-4 w-4 xl:h-6 xl:w-6"
                  />
                  　{name[selectedIndex]}
                </div>
              </button>
            </div>
          </animated.div>
        </div>
      )}
    </>
  )
}

export default IllustArray
